var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var _a, _b, _c, _d;
class KnownInternalNames {
}
KnownInternalNames.Exchanges = (_a = class {
    },
    __setFunctionName(_a, "Exchanges"),
    _a.Coinbase = "COINBASE",
    _a.Coinspot = "COINSPOT",
    _a.Gateio = "GATEIO",
    _a.Binance = "BINANCE",
    _a.Kucoin = "KUCOIN",
    _a.Huobi = "HUOBI",
    _a.FtxUs = "FTXUS",
    _a.FtxCom = "FTXCOM",
    _a.Okex = "OKEX",
    _a.Bitfinex = "BITFINEX",
    _a.Kraken = "KRAKEN",
    _a.Bittrex = "BITTREX",
    _a.CryptoCom = "CRYPTOCOM",
    _a.CryptoComApp = "CRYPTOCOMAPP",
    _a.BinanceUS = "BINANCEUS",
    _a.Blocktane = "BLOCKTANE",
    _a.MexcGlobal = "MEXC",
    _a);
KnownInternalNames.Networks = (_b = class {
    },
    __setFunctionName(_b, "Networks"),
    _b.CronosMainnet = "CRONOS_MAINNET",
    _b.OsmosisMainnet = "OSMOSIS_MAINNET",
    _b.ArbitrumMainnet = "ARBITRUM_MAINNET",
    _b.ArbitrumNova = "ARBITRUMNOVA_MAINNET",
    _b.ArbitrumRinkeby = "ARBITRUM_RINKEBY",
    _b.ArbitrumGoerli = "ARBITRUM_GOERLI",
    _b.ArbitrumSepolia = "ARBITRUM_SEPOLIA",
    _b.ModMainnet = "MODE_MAINNET",
    _b.OptimismMainnet = "OPTIMISM_MAINNET",
    _b.OptimismGoerli = "OPTIMISM_GOERLI",
    _b.OptimismKovan = "OPTIMISM_KOVAN",
    _b.RoninMainnet = "RONIN_MAINNET",
    _b.BobaMainnet = "BOBA_MAINNET",
    _b.BobaRinkeby = "BOBA_RINKEBY",
    _b.ZksyncEraMainnet = "ZKSYNCERA_MAINNET",
    _b.ZkspaceMainnet = "ZKSPACE_MAINNET",
    _b.EthereumMainnet = "ETHEREUM_MAINNET",
    _b.EthereumGoerli = "ETHEREUM_GOERLI",
    _b.EthereumSepolia = "ETHEREUM_SEPOLIA",
    _b.PolygonMainnet = "POLYGON_MAINNET",
    _b.LoopringMainnet = "LOOPRING_MAINNET",
    _b.LoopringGoerli = "LOOPRING_GOERLI",
    _b.LoopringSepolia = "LOOPRING_SEPOLIA",
    _b.MoonbeamMainnet = "MOONBEAM_MAINNET",
    _b.StarkNetGoerli = "STARKNET_GOERLI",
    _b.StarkNetMainnet = "STARKNET_MAINNET",
    _b.StarkNetSepolia = "STARKNET_SEPOLIA",
    _b.ImmutableZkEVM = "IMMUTABLEZK_MAINNET",
    _b.ImmutableZkTestnet = "IMMUTABLEZK_TESTNET",
    _b.AstarMainnet = "ASTAR_MAINNET",
    _b.NahmiiMainnet = "NAHMII_MAINNET",
    _b.RhinoFiMainnet = "RHINOFI_MAINNET",
    _b.DydxMainnet = "DYDX_MAINNET",
    _b.DydxGoerli = "DYDX_GOERLI",
    _b.BNBChainMainnet = "BSC_MAINNET",
    _b.SolanaMainnet = "SOLANA_MAINNET",
    _b.SolanaTestnet = "SOLANA_TESTNET",
    _b.SolanaDevnet = "SOLANA_DEVNET",
    _b.SoonMainnet = "SOON_MAINNET",
    _b.SoonTestnet = "SOON_TESTNET",
    _b.SorareStage = "SORARE_MAINNET",
    _b.KCCMainnet = "KCC_MAINNET",
    _b.OKCMainnet = "OKC_MAINNET",
    _b.PolygonZkMainnet = "POLYGONZK_MAINNET",
    _b.LineaMainnet = "LINEA_MAINNET",
    _b.BaseMainnet = "BASE_MAINNET",
    _b.BaseSepolia = "BASE_SEPOLIA",
    _b.AvalancheMainnet = "AVAX_MAINNET",
    _b.PGNMainnet = "PGN_MAINNET",
    _b.PGNTestnet = "PGN_TESTNET",
    _b.MantleMainnet = "MANTLE_MAINNET",
    _b.ZoraMainnet = "ZORA_MAINNET",
    _b.RolluxMainnet = "ROLLUX_MAINNET",
    _b.OpBNBMainnet = "OPBNB_MAINNET",
    _b.MantaMainnet = "MANTA_MAINNET",
    _b.ScrollMainnet = "SCROLL_MAINNET",
    _b.TONMainnet = "TON_MAINNET",
    _b.TONTestnet = "TON_TESTNET",
    _b.BrineMainnet = "BRINE_MAINNET",
    _b.BlastSepolia = "BLAST_SEPOLIA",
    _b.BlastMainnet = "BLAST_MAINNET",
    _b.ParadexTestnet = "PARADEX_TESTNET",
    _b.ParadexMainnet = "PARADEX_MAINNET",
    _b.FuelMainnet = "FUEL_MAINNET",
    _b.FuelTestnet = "FUEL_TESTNET",
    _b.FuelDevnet = "FUEL_DEVNET",
    _b.TronMainnet = "TRON_MAINNET",
    _b.TronTestnet = "TRON_TESTNET",
    _b.EclipseTestnet = "ECLIPSE_TESTNET",
    _b.EclipseMainnet = "ECLIPSE_MAINNET",
    _b.SophonMainnet = "SOPHON_MAINNET",
    _b.SophonSepolia = "SOPHON_SEPOLIA",
    _b.RedStoneMainnet = "REDSTONE_MAINNET",
    _b.SoneiumMainnet = "SONEIUM_MAINNET",
    _b.RariMainnet = "RARI_MAINNET",
    _b.LightlinkMainnet = "LIGHTLINK_MAINNET",
    _b.ZetachainMainnet = "ZETACHAIN_MAINNET",
    _b.AvaxMainnet = "AVAX_TESTNET",
    _b.XaiMainnet = "XAI_MAINNET",
    _b.UnichainMainnet = "UNICHAIN_MAINNET",
    _b.XlayerMainnet = "XLAYER_MAINNET",
    _b.FraxtalMainnet = "FRAXTAL_MAINNET",
    _b.WorldchainMainnet = "WORLDCHAIN_MAINNET",
    _b.AbstractMainnet = "ABSTRACT_MAINNET",
    _b.CeloMainnet = "CELO_MAINNET",
    _b.KromaMainnet = "KROMA_MAINNET",
    _b.ShapeMainnet = "SHAPE_MAINNET",
    _b.GnosisMainnet = "GNOSIS_MAINNET",
    _b.TaikoMainnet = "TAIKO_MAINNET",
    _b.InkMainnet = "INK_MAINNET",
    _b.MintMainnet = "MINT_MAINNET",
    _b.Ancient8Mainnet = "ANCIENT8_MAINNET",
    _b.BobMainnet = "BOB_MAINNET",
    _b.FuseMainnet = "FUSE_MAINNET",
    _b.SonicMainnet = "SONIC_MAINNET",
    _b.ZeroMainnet = "ZERO_MAINNET",
    _b.ZircuitMainnet = "ZIRCUIT_MAINNET",
    _b.SuperseedMainnet = "SUPERSEED_MAINNET",
    _b.LiskMainnet = "LISK_MAINNET",
    _b.MorphMainnet = "MORPH_MAINNET",
    _b.SeiMainnet = "SEI_MAINNET",
    _b.GravityMainnet = "GRAVITY_MAINNET",
    _b.BitcoinMainnet = "BITCOIN_MAINNET",
    _b.BitcoinTestnet = "BITCOIN_TESTNET",
    _b.HyperliquidMainnet = "HYPERLIQUID_MAINNET",
    _b.HyperliquidTestnet = "HYPERLIQUID_TESTNET",
    _b.PolymarketMainnet = "POLYMARKET_MAINNET",
    _b.MonadMainnet = "MONAD_MAINNET",
    _b.TempoMainnet = "TEMPO_MAINNET",
    _b.TempoTestnet = "TEMPO_TESTNET",
    _b);
KnownInternalNames.Currencies = (_c = class {
    },
    __setFunctionName(_c, "Currencies"),
    _c.USDT = "USDT",
    _c.ETH = "ETH",
    _c.USDC = "USDC",
    _c.USDCe = "USDC.e",
    _c.USDCE = "USDC.E",
    _c.LRC = "LRC",
    _c.IMX = "IMX",
    _c.SNX = "SNX",
    _c.ZKS = "ZKS",
    _c);
KnownInternalNames.LiquidityProviders = (_d = class {
    },
    __setFunctionName(_d, "LiquidityProviders"),
    _d.ConnextId = "39BF4D10-0AF8-4F54-A8B1-4C69A81ACA14".toLowerCase(),
    _d.LayerSwapId = "168D5457-05ED-46E3-AAB3-72A2D2098F0F".toLowerCase(),
    _d.StarkNetId = "fa3f93eb-9fea-44f3-a8a6-a5ced0f6d646".toLowerCase(),
    _d);
export default KnownInternalNames;
